import { UserRole } from '../../../core/auth/services/token';

export interface SidebarItem {
  label: string;
  route: string; // ignored when children exist (accordion parent)
  icon: string;
  roles?: UserRole[];
  children?: SidebarItem[];
}

export const SIDEBAR_ITEMS_EMPLOYEE: SidebarItem[] = [
  { label: 'Tableau de bord', route: '/salarie', icon: 'home' },
  {
    label: 'Bulletins de paie',
    route: `/salarie/bulletin-de-paie/`,
    icon: 'library_books',
  },
  {
    label: 'Traitement Paie',
    route: '/salarie/traitement-paie',
    icon: 'fact_check',
    roles: ['ROLE_RH'],
  },
  {
    label: 'Mes temps',
    route: '/salarie/timesheet',
    icon: 'calendar_add_on',
  },
  {
    label: 'Mes absences',
    route: '/salarie/demande-absence',
    icon: 'beach_access',
  },
  {
    label: 'Mes frais',
    route: '/salarie/frais',
    icon: 'receipt',
  },
  {
    label: 'Mes collaborateurs',
    route: '/salarie/employee/liste',
    icon: 'groups',
    roles: ['ROLE_RH'],
  },
  {
    label: 'Mes projets',
    route: '/salarie/projets/liste',
    icon: 'folder_open',
  },
  {
    label: 'Gestions de projets',
    route: '/salarie/projets/management',
    icon: 'description',
    roles: ['ROLE_RH'],
  },

  {
    label: 'Documents',
    route: '/salarie/documents',
    icon: 'description',
    roles: ['ROLE_RH'],
  },
  {
    label: 'Pointage',
    route: '/salarie/time-clock',
    icon: 'access_time',
    roles: ['ROLE_RH'],
  },
  {
    label: 'Formation et Carrière',
    route: '/salarie/formation-carriere',
    icon: 'school',
    roles: ['ROLE_RH'],
  },
  {
    label: 'HSE',
    route: '/salarie/hse',
    icon: 'shield_with_heart',
    roles: ['ROLE_RH'],
  },
  // {
  //   label: 'Déclaration FDS',
  //   route: '/employee/declaration-fds',
  //   icon: 'forward_to_inbox',
  //   roles: ['ROLE_RH'],
  // },
  // {
  //   label: 'Déclaration CNAS',
  //   route: '/employee/declaration-cnas',
  //   icon: 'shield_with_heart',
  //   roles: ['ROLE_RH'],
  // },
  {
    label: 'Organisme et déclaration',
    route: '/salarie/cnas',
    icon: 'account_balance',
    roles: ['ROLE_RH'],
    children: [
      {
        label: 'Déclaration FDS',
        route: '/salarie/declaration/fds',
        icon: 'forward_to_inbox',
      },
      {
        label: 'Déclaration CNAS',
        route: '/salarie/declaration/cnas',
        icon: 'shield_with_heart',
      },
      {
        label: 'Déclaration IRG',
        route: '/salarie/declaration/irg',
        icon: 'request_quote',
      },
      {
        label: 'Affiliation CASNOS',
        route: '/salarie/declaration/casnos',
        icon: 'admin_panel_settings',
      },
    ],
  },
  {
    label: 'Élément de rémunération',
    route: '/salarie/remuneration/elements',
    icon: 'account_balance_wallet',
    roles: ['ROLE_RH'],
  },
  {
    label: 'Paramétres',
    route: '/admin-entreprise/settings',
    icon: 'settings',
    roles: ['ROLE_RH'],
  },
  // {
  //   label: 'Vérifier et clôturer la paie',
  //   route: '/employee/collaborateurs/verifier-cloturer-paie',
  //   icon: 'confirmation_number',
  //   roles: ['ROLE_RH'],
  // },
];

export const SIDEBAR_ITEMS_ADMIN: SidebarItem[] = [
  { label: 'Tableau de bord', route: '/admin-entreprise', icon: 'home' },
  {
    label: 'Traitement Paie',
    route: '/admin-entreprise/traitement-paie',
    icon: 'fact_check',
  },
  // {
  //   label: 'Demandes à valider',
  //   route: '/admin-entreprise',
  //   icon: 'verified',
  // },
  // {
  //   label: 'Vérifier et clôturer la paie',
  //   route: '/admin-entreprise/saisie-paie',
  //   icon: 'local_activity',
  // },
  {
    label: 'Mes collaborateurs',
    route: '/salarie/employee/liste',
    icon: 'groups',
  },
  {
    label: 'Élément de rémunération',
    route: '/salarie/remuneration/elements',
    icon: 'account_balance_wallet',
  },
  // {
  //   label: 'Temps de travail',
  //   route: '/admin-entreprise',
  //   icon: 'nest_clock_farsight_analog',
  // },

  // {
  //   label: 'Ajouter salarié',
  //   route: '/admin-entreprise',
  //   icon: 'receipt',
  // },
  // {
  //   label: 'Vérifier et clôturer la paie',
  //   route: '/employee/collaborateurs/verifier-cloturer-paie',
  //   icon: 'confirmation_number',
  // },

  {
    label: 'organisme et déclaration',
    route: '/admin-entreprise/declaration-cnas',
    icon: 'account_balance',
    children: [
      {
        label: 'Déclaration FDS',
        route: '/admin-entreprise/declaration/fds',
        icon: 'forward_to_inbox',
      },
      {
        label: 'Déclaration CNAS',
        route: '/admin-entreprise/declaration/cnas',
        icon: 'shield_with_heart',
      },
      {
        label: 'Déclaration IRG',
        route: '/admin-entreprise/declaration/irg',
        icon: 'request_quote',
      },
      {
        label: 'Affiliation CASNOS',
        route: '/admin-entreprise/declaration/casnos',
        icon: 'admin_panel_settings',
      },
    ],
  },
  {
    label: 'Paramétres',
    route: '/admin-entreprise/settings',
    icon: 'settings',
  },
];
export const SIDEBAR_ITEMS_SUPER_ADMIN: any[] = [
  { label: 'Tableau de bord', route: '/admin-global', icon: 'home' },
  {
    label: 'Entreprises',
    route: '/admin-global/entreprises',
    icon: 'apartment',
  },
];
